import React from "react";
import ExplainList from "features/Explain/ExplainList";
import PageContent from "ui/PageContent";

const ExplainOverview = () => {
  return (
    <PageContent
      title="EXPLAIN Plans"
      pageCategory="queries"
      pageName="explains"
    >
      <ExplainList />
    </PageContent>
  );
};

export default ExplainOverview;
